import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';

export function useSingleBusinessTransaction({
  reference,
  enabled = true,
}: {
  reference: string;
  enabled?: boolean;
}) {
  const api = useApi();

  return useQuery({
    queryKey: ['business-merchant/report/get-transaction', reference], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: `business-merchant/report/get-transaction/${reference}`,
      });
      return res;
    },
    enabled,
    retry: false,
  });
}
